import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { ReviewsModel, ReviewEntities, ReviewsPaths } from 'client/data/models/dealer-reviews';
import { DEALER_PROPS } from 'client/constants/dealer-reviews';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';
import { DealerReviewsLoading } from 'site-modules/dealerships/components/dealer-reviews-section/components/dealer-reviews-loading/dealer-reviews-loading';
import { ReviewsListLayout } from 'site-modules/dealerships/components/dealer-reviews-section/components/reviews-list-layout/reviews-list-layout';

function DealerReviewsSectionUI({
  allReviewsByType: allReviewsByTypeProp = undefined,
  params = {},
  reviewsType,
  initialCount = 0,
  totalReviews,
  newReviewsCount,
  onMaxAmountExpanded,
  isMobile,
}) {
  const [allReviewsByType, setAllReviewsByType] = useState(allReviewsByTypeProp);
  const previousReviewsTab = usePrevious(reviewsType);

  if (allReviewsByTypeProp && allReviewsByType !== allReviewsByTypeProp) {
    setAllReviewsByType(allReviewsByTypeProp);
  }

  useEffect(() => {
    if (previousReviewsTab !== reviewsType) {
      onMaxAmountExpanded(false);
    }
    // eslint-disable-next-line
  }, [reviewsType]);

  if (!allReviewsByType || previousReviewsTab !== reviewsType) {
    return <DealerReviewsLoading />;
  }

  return (
    <ReviewsListLayout
      allReviewsByType={allReviewsByType}
      reviewsType={reviewsType}
      params={params}
      initialCount={initialCount}
      totalReviews={totalReviews}
      newReviewsCount={newReviewsCount}
      onMaxAmountExpanded={onMaxAmountExpanded}
      isMobile={isMobile}
    />
  );
}

DealerReviewsSectionUI.propTypes = {
  allReviewsByType: PropTypes.shape({
    allReviews: PropTypes.arrayOf(ReviewEntities.ReviewEntity),
  }),
  params: DEALER_PROPS,
  reviewsType: PropTypes.string.isRequired,
  initialCount: PropTypes.number,
  totalReviews: PropTypes.number.isRequired,
  newReviewsCount: PropTypes.number.isRequired,
  onMaxAmountExpanded: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export const stateToPropsConfig = {
  allReviewsByType: bindToPath(
    ({ reviewsType, params: { dealerId } }) =>
      ReviewsPaths.getDealershipReviewsByTypePath({ dealerId, type: reviewsType }),
    ReviewsModel,
    null,
    false
  ),
};

export const DealerReviewsSection = connectToModel(DealerReviewsSectionUI, stateToPropsConfig);
